import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

const ButtonInputClear = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-button-input-clear', ...classNames]} />
);

ButtonInputClear.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonInputClear;
